// AKA Customer Aggrement Link
import { OMS_VIEW_BIG_RECEIPT_PATH, VIEW_B2B_INSTORE_RECEIPT_PATH, VIEW_B2C_INSTORE_RECEIPT_PATH, } from '../../constants/paths';
import { apiB2B, apiB2BWithBlob, apiB2C } from '../axios-client';
export var GetBigReceiptAPI = function (requestData) {
    return apiB2BWithBlob.post(OMS_VIEW_BIG_RECEIPT_PATH, requestData);
};
export var GetB2BInStoreReceiptAPI = function (requestData) {
    return apiB2B.post(VIEW_B2B_INSTORE_RECEIPT_PATH, requestData);
};
export var GetB2CInStoreReceiptAPI = function (requestData) {
    return apiB2C.post(VIEW_B2C_INSTORE_RECEIPT_PATH, requestData);
};
